import { render, staticRenderFns } from "./TruncateText.vue?vue&type=template&id=f07fae4e&scoped=true&"
import script from "./TruncateText.vue?vue&type=script&lang=js&"
export * from "./TruncateText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07fae4e",
  null
  
)

export default component.exports